import React from 'react';
import {
  AlertCircle, AlertTriangle, ArrowDownAZ, ArrowLeft, ArrowUpAZ,
  BarChart2, Building2, Calendar, Camera, Check, CheckCircle, CheckSquare,
  ChevronDown, ChevronLeft, ChevronRight, ChevronUp, ChevronsLeft, ChevronsRight, ChevronsUpDown,
  ClipboardEdit, ClipboardList, Copy, CreditCard, Download,
  Edit2, Edit3, Eye, FileDown, FileQuestion, FileSpreadsheet, FileText, Filter,
  GitMerge, HelpCircle, History, Home, Image, Info, Layers, LayoutGrid, Link, List, Loader, LogOut,
  Mail, Map, MapPin, Menu, MoreVertical, Paperclip, Pencil, Phone,
  Plus, PlusCircle, RefreshCw, RotateCcw, Save, Search, SearchX, Send, SlidersHorizontal,
  Star, Tag, Trash2, Upload, User, UserCheck, UserPlus, UserSearch, UserX, Users,
  ExternalLink, X, XCircle, Zap,
  Activity, Clock, Package, PieChart, TrendingUp,
} from 'lucide-react';
// Ojo: este `Image` tapa el constructor `Image` del navegador dentro de ESTE
// archivo. Acá no se usa (el `new Image()` que redimensiona fotos vive en
// utils/imageResize.js, otro módulo), pero si algún día hace falta uno acá, va
// como `window.Image`.

// Static map → tree-shakeable. Only icons actually referenced in the app are bundled.
const ICONS = {
  AlertCircle, AlertTriangle, ArrowDownAZ, ArrowLeft, ArrowUpAZ,
  BarChart2, Building2, Calendar, Camera, Check, CheckCircle, CheckSquare,
  ChevronDown, ChevronLeft, ChevronRight, ChevronUp, ChevronsLeft, ChevronsRight, ChevronsUpDown,
  ClipboardEdit, ClipboardList, Copy, CreditCard, Download,
  Edit2, Edit3, Eye, FileDown, FileQuestion, FileSpreadsheet, FileText, Filter,
  GitMerge, History, Home, Image, Info, Layers, LayoutGrid, Link, List, Loader, LogOut,
  Mail, Map, MapPin, Menu, MoreVertical, Paperclip, Pencil, Phone,
  Plus, PlusCircle, RefreshCw, RotateCcw, Save, Search, SearchX, Send, SlidersHorizontal,
  Star, Tag, Trash2, Upload, User, UserCheck, UserPlus, UserSearch, UserX, Users,
  ExternalLink, X, XCircle, Zap,
  Activity, Clock, Package, PieChart, TrendingUp,
};

function Icon({
  name,
  size = 24,
  color = "currentColor",
  className = "",
  strokeWidth = 2,
  ...props
}) {
  const IconComponent = ICONS[name];

  if (!IconComponent) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn(`<Icon name="${name}" /> not registered in AppIcon.jsx`);
    }
    return <HelpCircle size={size} color="gray" strokeWidth={strokeWidth} className={className} {...props} />;
  }

  return (
    <IconComponent
      size={size}
      color={color}
      strokeWidth={strokeWidth}
      className={className}
      {...props}
    />
  );
}
export default Icon;
